import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from './pipe.service';
import { environment } from 'src/enviroment/environment';

@Injectable({
  providedIn: 'root',
})
export class CallcenterService {
  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) { }

  // Login with existing callcenter credentials
  loginCallcenterWithExisting(credentials: { email: string, password: string }): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/auth/login', credentials).pipe(
      this.errorHandler.handleError()
    );
  }

  // Sign up as a new Call center
  signUpAsCallcenter(details: { email: string, password: string }): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/auth/register', details).pipe(
      this.errorHandler.handleError()
    );
  }

  // Fetch all candidates with pagination
  getCandidates(page: number, pageSize: number): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', pageSize.toString());

    return this.http.get<any>(environment.serverUrl + '/api/candidate/getAll', { params }).pipe(
      this.errorHandler.handleError()
    );
  }

  // Update candidate status
  updateStatus(empCode: string, payload: any): Observable<any> {
    return this.http
      .put<any>(`${environment.serverUrl}/api/candidate/${empCode}/updateStatus`, payload)
      .pipe(this.errorHandler.handleError());
  }
}